import React, { Dispatch, SetStateAction, createContext, useContext, useState } from 'react';
import { CampaignType } from '@anytag/graphql';
import { PostReportSegmentStatus } from './TikTokCampaignReportTable';

interface TikTokCampaignReportContextType {
  hasTracking: boolean;
  campaignType: CampaignType;
  segmentStatus: PostReportSegmentStatus;
  setSegmentStatus: Dispatch<SetStateAction<PostReportSegmentStatus>>;
}

const TikTokCampaignReportContext = createContext<TikTokCampaignReportContextType>(
  {} as TikTokCampaignReportContextType
);

export const useTikTokCampaignReportContext = () => useContext(TikTokCampaignReportContext);

interface InfluencerProviderProps {
  children: React.ReactElement | Array<React.ReactElement>;
}

export const TikTokCampaignReportProvider = ({ children }: InfluencerProviderProps) => {
  const [segmentStatus, setSegmentStatus] = useState<PostReportSegmentStatus>({
    post: false,
    total: false,
    influencer: false
  });

  return (
    <TikTokCampaignReportContext.Provider
      value={{
        segmentStatus,
        setSegmentStatus,
        hasTracking: true, // Tiktok special campaign always has tracking POST by default
        campaignType: CampaignType.TIKTOK_SPECIAL
      }}
    >
      {children}
    </TikTokCampaignReportContext.Provider>
  );
};
